import {useMemo} from 'react'
import {useInfiniteTimelinePageData} from '../../../page-data/loaders/use-timeline'
import {usePullRequestBasePath} from '../../../stores/selectors'
import {useDockedPanelMetadata} from '../../../contexts/DockedPanelContext'
import {TimelineActivityGroup} from './TimelineActivityGroup'
import {TimelineItemList} from './TimelineItemList'
import {useInfiniteScrollLoad} from './use-infinite-scroll-load'

export function TimelinePanelContent() {
  const metadata = useDockedPanelMetadata()

  if (metadata?.activityGroup) {
    return <TimelineActivityGroup {...metadata.activityGroup} />
  }

  return <FullTimeline />
}

function FullTimeline() {
  const pathName = usePullRequestBasePath()
  const {data, fetchNextPage, hasNextPage, isFetchingNextPage} = useInfiniteTimelinePageData({pathName})
  const items = useMemo(() => data.pages.flatMap(page => page.data), [data.pages])
  const sentinel = useInfiniteScrollLoad({
    fetchNextPage,
    hasMore: hasNextPage,
    isFetchingNextPage,
  })

  return (
    <div role="region" aria-label="Timeline events">
      <TimelineItemList
        items={items}
        clipSidebar={hasNextPage && isFetchingNextPage ? false : 'end'}
        sentinel={sentinel}
      />
    </div>
  )
}
